import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Breadcrumb!=!/root/frontend/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Modal","Button"] */ "__barrel_optimize__?names=Button,Modal!=!/root/frontend/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/frontend/src/aloEjare/postDetail/postDetail.index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/frontend/src/components/appLink/appLink.index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/frontend/src/components/base/base.index.tsx");
;
import(/* webpackMode: "eager" */ "/root/frontend/src/components/categoryBreadcrumb/categoryBreadcrumb.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/frontend/src/components/clientRender/clientRender.index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/frontend/src/components/gallery/gallery.index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/frontend/src/components/mobileHeader/mobileHeader.index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/frontend/src/components/postCard/postCard.index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/frontend/src/components/postContact/postContact.index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/frontend/src/components/slider/slider.index.tsx");
